const promotionsTypeInfo = [
  {
    promoType: '1',
    title: '<strong>โปรโมชันแบบส่วนลดตามจำนวน<br/>(Quantity Discount)</strong>',
    body: `
      <p><strong>ลักษณะของโปรโมชันเหล่านี้:</strong></p>
      <ul class="list-unstyled">
        <li><strong>1. ซื้อครบ X ชิ้น ลดราคาเหลือ Y บาท (ต่อชิ้น):</strong></li>
        <ul>
          <li>เมื่อลูกค้าซื้อสินค้าครบจำนวนที่กำหนด จะได้รับส่วนลดราคาต่อชิ้นที่ถูกลง เช่น ซื้อครบ 5 ชิ้น เหลือ 50 บาทต่อชิ้นจากราคาปกติ 60 บาท</li>
          <li><strong>เป็นการส่งเสริมให้ลูกค้าซื้อเพิ่ม เพื่อให้ได้ราคาที่คุ้มค่าขึ้นต่อหน่วย</strong></li>
        </ul>
        <li><strong>2. ซื้อครบ X ชิ้น ลดราคา Y % (ต่อชิ้น):</strong></li>
        <ul>
          <li>เมื่อลูกค้าซื้อสินค้าครบจำนวนที่กำหนด จะได้รับส่วนลดเป็นเปอร์เซ็นต์ตามที่กำหนด เช่น ซื้อครบ 10 ชิ้น ลด 20% ต่อชิ้น</li>
          <li><strong>ช่วยจูงใจให้ลูกค้าซื้อจำนวนมากขึ้น เพื่อรับส่วนลดที่มากขึ้นต่อชิ้น</strong></li>
        </ul>
      </ul>
      <p>โปรโมชันนี้นิยมใช้ในสินค้าที่มีความต้องการซื้อซ้ำสูง หรือสินค้าที่ต้องการระบายสต็อก</p>
    `,
  },
  {
    promoType: '2',
    title: '<strong>โปรโมชันส่วนลดตามยอดซื้อ<br/>(Threshold Discount)</strong>',
    body: `
    <p>โปรโมชันที่มอบส่วนลดเมื่อยอดสั่งซื้อถึงเกณฑ์ที่กำหนด เพื่อกระตุ้นให้ลูกค้าเพิ่มมูลค่าการซื้อ</p>
      <p><strong>รูปแบบหลัก:</strong></p>
      
       <ul>
        <li><strong>ลดเป็นจำนวนเงิน: </strong>เช่น ซื้อครบ 1,000 บาท ลด 100 บาท 
        และหากซื้อครบ 2,000 บาท ลด 200 บาท — สามารถตั้งลำดับขั้นส่วนลดและ
        กำหนดส่วนลดสูงสุดได้ตามต้องการ</li>
        <li><strong>ลดเป็นเปอร์เซ็นต์: </strong>เช่น ซื้อครบ 2,000 บาท ลด 10% — ช่วยกระตุ้น
        ให้ลูกค้าเพิ่มยอดซื้อเพื่อรับส่วนลดที่มากขึ้น
        </li>
      </ul>
      <p><strong>ประโยชน์:</strong> <br>ช่วยเพิ่มยอดขายเฉลี่ยต่อออเดอร์ (Average Order Value) เหมาะสำหรับ
      ร้านค้าปลีกและร้านค้าออนไลน์ที่ต้องการกระตุ้นยอดใช้จ่ายของลูกค้า</p>
    `,
  },
  // {
  //   promoType: '2',
  //   title: '<strong>โปรโมชันส่วนลดตามยอดซื้อ<br/>(Threshold Discount)</strong>',
  //   body: `
  //     <p><strong>ลักษณะและความหมาย:</strong></p>
  //      <ul class="list-unstyled">
  //       <li><strong>1. ซื้อครบ X บาท ลด Y บาท:</strong></li>
  //       <ul>
  //         <li>เมื่อมูลค่าซื้อสินค้ารวมอยู่ในเกณฑ์ที่กำหนด จะได้รับส่วนลดเป็นเงิน เช่น ซื้อครบ 1,000 บาท ลด 100 บาท</li>
  //         <li><strong>ช่วยกระตุ้นให้ลูกค้าปรับเพิ่มมูลค่าการสั่งซื้อให้เกินเกณฑ์ เพื่อรับส่วนลดทันที</strong></li>
  //       </ul>
  //       <li><strong>2. ซื้อครบ X บาท ลด Y %:</strong></li>
  //       <ul>
  //         <li>เมื่อมูลค่าซื้อสินค้ารวมอยู่ในเกณฑ์ที่กำหนด จะได้รับส่วนลดเป็นเปอร์เซ็นต์ เช่น ซื้อครบ 2,000 บาท ลด 10%</li>
  //         <li><strong>กระตุ้นให้ลูกค้าใช้จ่ายเพิ่มขึ้นเพื่อรับส่วนลดที่สูงขึ้นตามยอดซื้อ</strong></li>
  //       </ul>
  //       <li>ตัวอย่าง:</li>
  //       <ul>
  //         <li>ซื้อครบ <strong>500 บาท</strong> ลด <strong>50 บาท</strong></li>
  //         <li>ซื้อครบ <strong>3,000 บาท</strong> ลด <strong>15%</strong></li>
  //       </ul>
  //       <li>ความแตกต่าง:</li>
  //       <ul>
  //         <li><strong>แบบลดเป็นจำนวนเงิน (บาท):</strong>ช่วยให้ลูกค้ารู้สึกว่าได้ลดแบบชัดเจนเหมาะะกับการตั้งเป้ายอดซื้อไม่สูงมาก เช่น ลด 50 บาท เมื่อซื้อครบ 500 บาท</li>
  //         <li><strong>แบบลดเป็นเปอร์เซ็นต์ (%):</strong>เหมาะกับการดึงดูดลูกค้าที่ซื้อสินค้ามูลค่าสูง เช่น ลด 10% เมื่อซื้อครบ 2,000 บาท</li>
  //       </ul>
  //       <li>โปรโมชันเหล่านี้เหมาะสำหรับการเพิ่มยอดขายเฉลี่ยต่อการซื้อ (Average Order Value) และมักใช้กับธุรกิจค้าปลีกหรือร้านค้าออนไลน์</li>
  //     </ul>
  //   `,
  // },
  {
    promoType: '3',
    title: '<strong>โปรโมชันแบบเหมาจ่าย<br/>(Fixed Price Bundle)</strong>',
    body: `
    
      <ul class="list-unstyled">
      <ul>
        <li>ลูกค้าจ่ายราคาที่กำหนดไว้สำหรับจำนวนสินค้าที่กำหนด เช่น ซื้อ 3 ชิ้น จ่าย 100 บาท ซึ่งให้ความรู้สึกกว่าคุ้มค่า เมื่อเปรียบเทียบกับการซื้อสินค้ารายชิ้น</li>
        <li>ใช้กระตุ้นให้ลูกค้าซื้อสินค้าเพิ่มขึ้น เพื่อให้ได้ราคาที่ถูกลง หรือสร้างความรู้สึกว่าลูกค้าจ่ายในราคาพิเศษ</li>
      </ul>
      <li>ตัวอย่าง:</li>
      <ul>
        <li><strong>ซื้อ 5 ชิ้น จ่าย 199 บาท</strong> (จากราคาปกติที่สูงกว่า 199 บาท เมื่อซื้อแยก)</li>
        <li><strong>ซื้อ 2 ชิ้น จ่าย 100 บาท</strong> ซึ่งราคาปกติอาจเป็นชิ้นละ 60 บาท เป็นต้น</li>
      </ul>
      <li>โปรโมชันเหล่านี้เหมาะสำหรับการเพิ่มยอดขายเฉลี่ยต่อการซื้อ (Average Order Value) และมักใช้กับธุรกิจค้าปลีกหรือร้านค้าออนไลน์</li>
      </ul>
    `,
  },
  {
    promoType: '4',
    title: 'โปรโมชันของแถม<br/>(Buy More, Get More)',
    body: `
      <p>ลักษณะของแต่ละประเภท:</p>
       <ul class="list-unstyled">
        <li><strong>1. ซื้อครบ X ชิ้น แถม Y ชิ้น (Buy X, Get Y Free):</strong></li>
        <ul>
          <li>เมื่อลูกค้าซื้อสินค้าจำนวนที่กำหนด จะได้รับสินค้าฟรีจำนวนที่ระบุ เช่น ซื้อครบ 3 ชิ้น แถม 1 ชิ้น</li>
          <li>ใช้ดึงดูดให้ลูกค้าซื้อสินค้าจำนวนมากขึ้น เพื่อให้ได้ของแถมเพิ่ม</li>
          <li>มักนิยมใช้กับสินค้าที่สามารถขายในจำนวนหลายชิ้น เช่น อาหาร ขนม หรือ เครื่องใช้ในบ้าน</li>
        </ul>
        <li class='px-2'><strong>ตัวอย่าง:</strong><li>
        <ul>
          <li>ซื้อครบ 5 ชิ้น แถมฟรี 1 ชิ้น</li>
          <li>ซื้อครบ 10 ชิ้น แถมฟรี 2 ชิ้น</li>
        </ul>
        <li><strong>2. ซื้อครบ X บาท แถม Y ฟรี (Spend X, Get Y Free):</strong></li>
        <ul>
          <li>เมื่อลูกค้าซื้อสินค้ารวมมูลค่าครบที่กำหนด จะได้รับของแถมฟรี เช่น ซื้อครบ 500 บาท แถม 1 ชิ้น</li>
          <li>ใช้เพื่อเพิ่มยอดซื้อเฉลี่ยต่อใบเสร็จ (Average Order Value) และส่งเสริมให้ลูกค้าซื้อสินค้าที่มูลค่าสูงขึ้น</li>
        </ul>
        <li class='px-2'><strong>ตัวอย่าง:</strong><li>
        <ul>
          <li>ซื้อครบ 1,000 บาม แถมฟรี 1 ชิ้น</li>
          <li>ซื้อครบ 2,000 บาม แถมฟรีสินค้าในหมวดหมู่ที่กำหนด</li>
        </ul>
        <li>ประโยชน์ของโปรโมชันแบบแถมฟรี:</li>
        <ul>
          <li>กระตุ้นการซื้อจำนวนมาก:</strong> ลูกค้าอยากได้ของแถมและยินดีซื้อเพิ่ม</li>
          <li><strong>เพิ่มความพึงพอใจ:</strong>ลูกค้ารู้สึกว่าคุ้มค่า เมื่อได้รับของแถม</li>
          <li><strong>ช่วยระบายสินค้า:</strong>สามารถใช้ของแถมเป็นสินค้าที่ต้องการโปรโมตหรือระบายสต็อกได้</li>
        </ul>
        <li><strong>ประโยชน์:</strong><li>
        <li class='px-2'>โปรโมชันนี้มักใช้กับธุรกิจค้าปลีก ร้านค้าออนไลน์ หรือ ธุรกิจที่ต้องการโปรโมตสินค้าบางประเภทเพื่อเพิ่มยอดขายและสร้างความจูงใจในการซื้อเพิ่ม<li>
        </ul>
    `,
  },
];

export default promotionsTypeInfo;
